var _a;
import { createSlice } from '@reduxjs/toolkit';
import { name } from './constants';
import { getInitialState } from './getInitialState';
export var idsMap = createSlice({
    name: name,
    initialState: getInitialState(),
    reducers: {
        getIdsMapPending: function (state) {
            state.loading = 'pending';
            state.error = null;
        },
        getIdsMapSuccess: function (state, action) {
            state.loading = 'fulfilled';
            state.data = action.payload;
            state.error = null;
        },
        getIdsMapError: function (state, action) {
            state.loading = 'rejected';
            state.error = action.payload;
        },
    },
});
export var getIdsMapPending = (_a = idsMap.actions, _a.getIdsMapPending), getIdsMapSuccess = _a.getIdsMapSuccess, getIdsMapError = _a.getIdsMapError;
